var AssetDirectory = {
	"load": [
		"assets/bgm/bgm.ogg",
		"assets/fonts/airbagfree-regular.woff",
		"assets/fonts/londonbetween.woff",
		"assets/htp/htp_weed1.png",
		"assets/htp/htp_weed2.png",
		"assets/htp/htp_weed3.png",
		"assets/htp/htp_weed4.png",
		"assets/htp/htp_weed5.png",
		"assets/ingame/bg_weeds.png",
		"assets/ingame/clover.png",
		"assets/ingame/fx_cut_sparkle_ske.json",
		"assets/ingame/fx_cut_sparkle_tex.json",
		"assets/ingame/fx_cut_sparkle_tex.png",
		"assets/ingame/fx_firsttimeplay_glow.png",
		"assets/ingame/weed.png",
		"assets/ingame/weed2.png",
		"assets/ingame/weed_particle1.png",
		"assets/ingame/weed_particle2.png",
		"assets/ingame/weed_particle3.png",
		"assets/ingame/weed_particle4.png",
		"assets/sfx/button_sfx.ogg",
		"assets/sfx/plant_select.ogg",
		"assets/sfx/score_points.ogg",
		"assets/sfx/star_gain.ogg",
		"assets/titlescreen/bg_logo_weeds.png",
		"assets/titlescreen/gizmo_weeds.png",
		"assets/titlescreen/logo_weeds1.png",
		"assets/titlescreen/logo_weeds2.png",
		"assets/ui/btn_audio1.png",
		"assets/ui/btn_audio2.png",
		"assets/ui/btn_audio3.png",
		"assets/ui/btn_audio4.png",
		"assets/ui/btn_exit.png",
		"assets/ui/btn_exit2.png",
		"assets/ui/btn_pause.png",
		"assets/ui/btn_pause2.png",
		"assets/ui/btn_play.png",
		"assets/ui/btn_play2.png",
		"assets/ui/btn_prevnext.png",
		"assets/ui/btn_prevnext2.png",
		"assets/ui/btn_replay.png",
		"assets/ui/btn_replay2.png",
		"assets/ui/btn_return.png",
		"assets/ui/btn_return2.png",
		"assets/ui/check-button1.png",
		"assets/ui/check-button2.png",
		"assets/ui/gfx_container.png",
		"assets/ui/gfx_container_white.png",
		"assets/ui/gfx_explode.png",
		"assets/ui/gfx_flare_long.png",
		"assets/ui/gfx_flare_star.png",
		"assets/ui/gfx_loading_bar_con.png",
		"assets/ui/gfx_pop.png",
		"assets/ui/gfx_pop2.png",
		"assets/ui/gfx_star0.png",
		"assets/ui/gfx_star1.png",
		"assets/ui/gfx_starbg.png",
		"assets/ui/x-button1.png",
		"assets/ui/x-button2.png"
	],
	"preload": [
		"assets/preload/fonts/Exo-Bold.otf",
		"assets/preload/fonts/Exo-Medium.ttf",
		"assets/preload/fonts/proximanova-black.otf",
		"assets/preload/strings/gizmoloading_ske.json",
		"assets/preload/strings/gizmoloading_tex.json",
		"assets/preload/strings/strings.json",
		"assets/preload/ui/gfx_bg.png",
		"assets/preload/ui/gfx_loading.png",
		"assets/preload/ui/gizmoloading_tex.png"
	],
	"preloadstring": [
		"assets/strings/config.json"
	]
};